import axios from '@/plugins/axios';

const LIST_MONTHLY_PLAN = '/monthly-plans/';
const CHANGE_MONTHLY_PLAN = '/monthly-plan/change';

export async function getListMonthlyPlan(params) {
  try {
    const { data } = await axios.get(LIST_MONTHLY_PLAN, { params });

    return data;
  } catch (error) {
    return { error };
  }
}

export async function changeMonthlyPlan(payload) {
  try {
    const { data } = await axios.post(CHANGE_MONTHLY_PLAN, payload);

    return data;
  } catch (error) {
    return { error };
  }
}
